import parseISO from "date-fns/fp/parseISO";
const toDate = (date) => typeof date === "string" ? parseISO(date) : date;
export {
  toDate
};
